// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"390":"b074ca21","488":"5cab9a1b","885":"2de7ea5a"}[chunkId] + ".chunk.js");